class Errors {

    constructor() {
        this.bag = {};
    }

    has(fields) {
        if (Array.isArray(fields)) {
            return this.hasArray(fields);
        }
        return this.bag.hasOwnProperty(fields);
    }

    hasArray(fields) {
        let all = window._.find(fields, (field) => {
            return this.bag.hasOwnProperty(field);
        });
        return all !== undefined;
    }

    any() {
        return Object.keys(this.bag).length > 0;
    }

    get(field) {
        if (this.has(field)) {
            return this.bag[field][0];
        }
    }

    set(field, rule) {
        this.bag[field] = [rule];
    }

    record(bag) {
        this.bag = bag;
    }

    display(field, rule) {
        return this.has(field) && this.bag[field][0] === rule;
    }

    clear(field = null) {
        if (field) {
            delete this.bag[field];
        } else {
            this.bag = {};
        }
    }
}

export default Errors;